module.exports = __webpack_public_path__ + "img/k_thumb.9044159f.gif";